import React from 'react';
import PropTypes from 'prop-types';
import {Line} from '../../task-row/task-row.styled';
import {
	BottomOneTableRow,
	BottomOneItem,
	BottomOneGreyItem,
	BottomOneDetailItem,
	BottomOneRightItem,
} from './style/bottom_one_style';
export const BottomOneRow = ({
	enabledColumns,
	isLastRow,
	isVisible,
	bottomOneItems,
	bottomOneDetailItems,
	bottomOneGreyItems,
	bottomOneRightItems,
	numberOfParents,
}) => {
	const list = [];
	let index = 0;

	if (isVisible) {
		if (bottomOneItems) {
			//looping through the bottom 1 simple items
			for (const key of Object.keys(bottomOneItems)) {
				if (enabledColumns[key] !== undefined && enabledColumns[key] !== 0) {
					list.push(
						<BottomOneItem order={enabledColumns[key]} key={index}>
							<span>{bottomOneItems[key]}</span>
						</BottomOneItem>
					);
					index++;
				}
			}
		}

		if (bottomOneRightItems) {
			//looping through the bottom 1 right aligned items
			for (const key of Object.keys(bottomOneRightItems)) {
				if (enabledColumns[key] !== undefined && enabledColumns[key] !== 0) {
					list.push(
						<BottomOneRightItem order={enabledColumns[key]} key={index}>
							<span>{bottomOneRightItems[key]}</span>
						</BottomOneRightItem>
					);
					index++;
				}
			}
		}

		if (bottomOneDetailItems) {
			//looping through the bottom 1  flex 1 items
			for (const key of Object.keys(bottomOneDetailItems)) {
				if (enabledColumns[key] !== undefined && enabledColumns[key] !== 0) {
					list.push(
						<BottomOneDetailItem order={enabledColumns[key]} key={index}>
							<span>{bottomOneDetailItems[key]}</span>
						</BottomOneDetailItem>
					);
					index++;
				}
			}
		}

		if (bottomOneGreyItems) {
			//looping through the bottom 1 simple grey items
			for (const key of Object.keys(bottomOneGreyItems)) {
				if (enabledColumns[key] !== undefined && enabledColumns[key] !== 0) {
					list.push(
						<BottomOneGreyItem order={enabledColumns[key]} key={index}>
							<span>{bottomOneGreyItems[key]}</span>
						</BottomOneGreyItem>
					);
					index++;
				}
			}
		}
	}

	return (
		<>
			<Line>
				<BottomOneTableRow isLastRow={isLastRow} numberOfParents={numberOfParents}>
					{list}
				</BottomOneTableRow>
			</Line>
		</>
	);
};

BottomOneRow.propTypes = {
	isVisible: PropTypes.bool,
	timeRegType: PropTypes.string,
	timeRegDetail: PropTypes.func,
	isLastRow: PropTypes.bool,
	timeRegId: PropTypes.string,
	reportedTime: PropTypes.string,
	assigneesElement: PropTypes.object,
	projectName: PropTypes.string,
	roleName: PropTypes.string,
	price: PropTypes.string,
	cost: PropTypes.string,
	notes: PropTypes.string,
	taskName: PropTypes.string,
	personIcon: PropTypes.object,
	showBottom: PropTypes.func,
	numberOfParents: PropTypes.number,
	date: PropTypes.string,
	departmentName: PropTypes.string,
	clientName: PropTypes.string,
	billable: PropTypes.string,
	personName: PropTypes.string,
	bottomOneItems: PropTypes.object,
	bottomOneDetailItems: PropTypes.object,
	bottomOneGreyItems: PropTypes.object,
	bottomOneRightItems: PropTypes.object,

	enabledColumns: PropTypes.shape({
		needingSpace: PropTypes.bool,
		timeRegType: PropTypes.bool,
		personName: PropTypes.bool,
		timeRegDetail: PropTypes.bool,
		timeRegId: PropTypes.bool,
		reportedTime: PropTypes.bool,
		assigneesElement: PropTypes.func,
		projectName: PropTypes.bool,
		roleName: PropTypes.bool,
		price: PropTypes.bool,
		cost: PropTypes.bool,
		notes: PropTypes.bool,
		taskName: PropTypes.bool,
		personIcon: PropTypes.bool,
		showBottom: PropTypes.bool,
		date: PropTypes.bool,
		clientName: PropTypes.bool,
		departmentName: PropTypes.bool,
		billable: PropTypes.bool,
	}).isRequired,
};
